import { downloadBrochureFiles } from '@/core/utils/brochureDownload';

/**
 * Download guest brochure document(s).
 * Single file → `{projectName}-brochure.{ext}`; multiple → `{projectName}-brochure.zip`.
 */
export async function openGuestDocument(
  urls: ReadonlyArray<string> | string,
  projectName: string,
): Promise<void> {
  const list = (Array.isArray(urls) ? urls : [urls]).filter(Boolean);
  await downloadBrochureFiles({ urls: list, projectName });
}
